import { useState, useEffect } from 'react';
import { StaffLoVResponse } from '@/api/generated/api';
import { staffApi } from '@/api/api';

interface UseStaffLoVReturn {
  staff: StaffLoVResponse[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useStaffLoV = (activeOnly: boolean = true): UseStaffLoVReturn => {
  const [staff, setStaff] = useState<StaffLoVResponse[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchStaff = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      const response = activeOnly 
        ? await staffApi.getActiveStaffLoV()
        : await staffApi.getAllStaffLoV();
      
      setStaff(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error('Chyba při načítání zaměstnanců:', err);
      setError(err instanceof Error ? err.message : 'Nepodařilo se načíst zaměstnance');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchStaff();
  }, [activeOnly]);

  return {
    staff,
    isLoading,
    error,
    refetch: fetchStaff,
  };
};

